import {getCurrentYear} from '../../utils/commons'
import TopReviews24Logo from './logo'
import {topReviews24StylesDE} from './styles'

const baseConfig = {
  domainName: 'topreviews24' as const,
  domainType: 'eu' as const,
  siteName: 'Top Reviews 24',
  favicon: '/favicons/topreviews24.png',
  styles: topReviews24StylesDE,
}

const localeConfigs = {
  de: {
    measurementId: 'G-40MFFKW2DK',
    camelCaseUrl: 'TopReviews24.com',
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} | Top Reviews 24 Vergleich`,
    description: (category?: string, count?: string) =>
      `Finde die besten ${count} ${category} im Vergleich ${getCurrentYear()} auf topreviews24.de. Aktuelle Kaufempfehlungen. Jetzt informieren und das beste Produkt finden`,
    logo: <TopReviews24Logo className="size-10 shrink-0 tablet:size-8" locale="de" />,
  },
}

export const createConfig = (locale: string = 'de') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.de
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
